export const Dot = () => {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9 9.75C9.41421 9.75 9.75 9.41421 9.75 9C9.75 8.58579 9.41421 8.25 9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75Z'
        stroke='#2E2E34'
        stroke-width='1.63447'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M14.25 9.75C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25C13.8358 8.25 13.5 8.58579 13.5 9C13.5 9.41421 13.8358 9.75 14.25 9.75Z'
        stroke='#2E2E34'
        stroke-width='1.63447'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M3.75 9.75C4.16421 9.75 4.5 9.41421 4.5 9C4.5 8.58579 4.16421 8.25 3.75 8.25C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75Z'
        stroke='#2E2E34'
        stroke-width='1.63447'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
